module.exports = __webpack_public_path__ + "static/media/output-sockets.9eef7c2c.png";